<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="baseFormLineInfo" slot-scope="prop">
        <ChooseLine
          :isRadio="true"
          :isInput="true"
          :disabled="prop.item.disabled"
          :customerInfo="prop.form.baseFormCustomerInfo"
          v-model="prop.form.baseFormLineInfo"
          @change="chooseLineChange"
        />
      </section>
      <section slot="baseFormCustomerInfo" slot-scope="prop">
        <ChooseCustomer
          :isRadio="true"
          :disabled="prop.item.disabled"
          :isInput="true"
          v-model="prop.form.baseFormCustomerInfo"
          :otherSearchData="{ state: 1, status: 2 }"
          @change="chooseCustomerChange"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import ChooseLine from 'components/chooseLine/chooseLine';
import ChooseCustomer from 'components/choose/customer';
import {
  queryLineList,
  queryCustomerInfo,
  queryIntelligentMatchVehicle,
} from 'api/operate';
import { formatDateTime } from '@qx/utils/index';
export default {
  components: {
    ChooseLine,
    ChooseCustomer,
  },
  data () {
    return {
      chooseCustomerDisabled: false,
      createDate: '',
      otherFormData: {
        orderId: '',
        orderInfoId: '',
        orderInfoExtId: '',
        orderFeeId: '',
        orderFeeExtId: '',
        orderGoodsId: '',
        orderSchedulerId: '',
      },
      baseForm: {
        inline: true,
        form: [
          {
            label: '选择线路',
            value: 'baseFormLineInfo',
            default: {},
            slot: true,
            disabled: false,
          },
          {
            label: '客户名称',
            value: 'baseFormCustomerInfo',
            default: {},
            slot: true,
            disabled: false,
          },
          {
            label: '发车时间',
            value: 'dependTime',
            type: 'date',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm',
            },
            onChange: (date) => {
              this.$emit('getDependTime', this.formatDate(date, 4));
            },
          },
          {
            label: '客户单号',
            value: 'customNumber',
            type: 'select',
            multiple: true,
            filterable: true,
            allowCreate: true,
            defaultFirstOption: true,
            placeholder: '多个单号使用回车分隔',
          },
        ],
        rules: {
          baseFormCustomerInfo: [
            { required: true, message: '请输入客户名称', trigger: 'blur' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请输入客户名称'),
              trigger: 'blur',
            },
          ],
          dependTime: [
            { required: true, message: '请输入发车时间', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      const formData = await this.sub();
      console.log(formData);
    },
    // 选择线路
    async chooseLineChange (lineInfo) {
      if (!lineInfo) {
        return;
      }
      const resLine = await queryLineList({
        customerId: lineInfo.customerId,
        lineCode: lineInfo.lineCodeRule,
      });
      // 获取客户信息
      let resCustomer = await queryCustomerInfo({
        customerId: lineInfo.customerId,
      });
      // 获取推荐车辆
      const resMatchVehicle = await queryIntelligentMatchVehicle({
        customerId: lineInfo.customerId,
        sourceId: lineInfo.lineId,
      });
      if (!resLine.failed) {
        if (resLine.items && resLine.items.length) {
          this.$refs.baseForm.setVal('baseFormCustomerInfo', resCustomer);
          this.$refs.baseForm.setVal('baseFormLineInfo', resLine.items[0]);
          let isPass = true;
          let message = '';
          if (resCustomer.authState !== 2) {
            message = '客户信息未认证，不能开单！';
            isPass = false;
          }
          if (!(resCustomer.lineName)) {
            message = '客户托运人为空，不能开单！';
            isPass = false;
          }
          if (!(resCustomer.linePhone)) {
            message = '客户托运人电话为空，不能开单！';
            isPass = false;
          }
          if (!isPass) {
            resCustomer = {};
            this.$message({
              type: 'warning',
              message,
            });
            return;
          }

          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'disabled',
            value: true,
            names: ['baseFormCustomerInfo'],
          });

          this.setDependTime(resLine.items[0].taiwanDate);
          this.$emit('getCombineinfo', {
            line: resLine.items[0],
            customer: resCustomer,
            matchVehicle: resMatchVehicle,
          });
        }
      }
    },
    // 选择客户
    async chooseCustomerChange (cusInfo) {
      if (!cusInfo) {
        return;
      }
      this.$refs.baseForm.setVal('baseFormCustomerInfo', cusInfo);
    },
    // 发车时间
    setDependTime (taiwanDate) {
      if (taiwanDate !== null) {
        const time = formatDateTime(new Date(), 1, 0);
        let dependTime = '';
        if (taiwanDate.length >= 16) {
          dependTime = time.substring(0, 11) + taiwanDate.substring(11, 16);
        }
        if (taiwanDate.length === 5) {
          dependTime = time.substring(0, 11) + taiwanDate;
        }
        this.$refs.baseForm.setVal('dependTime', dependTime);
        this.$emit('getDependTime', dependTime);
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData.dependTime = formData.dependTime ? this.formatDate(formData.dependTime, 4) : '';
        formData.createDate = this.createDate;
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        let customerInfo = {};
        for (let item in formData) {
          if (formData[item] !== null || formData[item] !== undefined) {
            if (item === 'customNumber') {
              if (formData[item].length) {
                customerInfo['customerInfo.' + item] = formData[item].join(',');
              }
            } else {
              if (item.includes('Id') && formData[item]) {
                // 修改订单
                if (item === 'orderId') {
                  customerInfo['customerInfo.' + item] = formData[item];
                }
                // 所有含有 Id 字样的，都赋值为 ids.xxx 提交
                customerInfo['ids.' + item] = formData[item];
              } else {
                // 其他的都以 customerInfo.xxx 提交
                customerInfo['customerInfo.' + item] = formData[item];
              }
            }
          }
        }
        let customerIdInfo = {};
        if (formData.baseFormCustomerInfo) {
          // 选择了客户
          const data = formData.baseFormCustomerInfo;
          customerIdInfo = {
            ['customerInfo.customerId']: data.customerId || '',
            ['customerInfo.customUserId']: data.customerId || '',
            ['customerInfo.customerName']: data.customerName || '',
            ['customerInfo.customName']: data.customerName || '',
            // 如果是自己输入的，没有 companyName 字段，所以用输入的 customerName 顶上
            ['customerInfo.companyName']: data.companyName || data.customerName || '',
          };
        }
        if (formData.baseFormLineInfo) {
          // 选择了线路
          const data = formData.baseFormLineInfo;
          customerIdInfo['customerInfo.lineId'] = data.lineId;
          // 这个参数传了代表是固定线路，不传就是临时
          customerIdInfo['customerInfo.sourceId'] = data.lineId;
          customerIdInfo['customerInfo.lineName'] = data.lineName;
          customerIdInfo['customerInfo.isUrgent'] = 0;
          customerIdInfo['customerInfo.pontagePer'] = (data.pontagePer) ? (data.pontagePer / 100.0).toFixed(2) : 0;
          customerIdInfo['customerInfo.oilCostPer'] = data.oilCostPer ? (data.oilCostPer / 100.0).toFixed(2) : 0;

          // 收货人
          customerIdInfo['customerInfo.reciveName'] = data.receiveName;
          customerIdInfo['customerInfo.recivePhone'] = data.receivePhone;
          // 托运人
          customerIdInfo['customerInfo.contactName'] = data.lineName || '';
          customerIdInfo['customerInfo.contactPhone'] = data.lineTel || '';
          // 经纬度
          customerIdInfo['customerInfo.nand'] = data.sourceNand || '';
          customerIdInfo['customerInfo.eand'] = data.sourceEand || '';
          customerIdInfo['customerInfo.eandDes'] = data.desEand || '';
          customerIdInfo['customerInfo.nandDes'] = data.desNand || '';
          customerIdInfo['customerInfo.sourceName'] = data.lineCodeName || '';

          customerIdInfo['customerInfo.addrDtl'] = data.source + data.sourceAddress;
          customerIdInfo['customerInfo.desDtl'] = data.des + data.desAddress;

          customerIdInfo['customerInfo.reciveAddr'] = data.reciveAddress || '';
          customerIdInfo['customerInfo.reciveAddress'] = (data.reciveProvinceName) ? data.reciveProvinceName : '';
        }
        customerInfo = {
          ...customerInfo,
          ...customerIdInfo,
        };
        delete customerInfo['customerInfo.baseFormLineInfo'];
        delete customerInfo['customerInfo.baseFormCustomerInfo'];
        delete customerInfo['customerInfo.chooseCustomerDisabled'];
        delete customerInfo['customerInfo.orderInfo'];
        delete customerInfo['customerInfo.orderGoods'];
        delete customerInfo['customerInfo.orderFee'];
        delete customerInfo['customerInfo.orderScheduler'];
        formData = customerInfo;
      }
      return formData;
    },
    setDetailData (data) {
      // 如果是修改模式
      data.baseFormLineInfo = data.baseFormLineInfo || {};
      data.baseFormCustomerInfo = data.baseFormCustomerInfo || {};
      data.baseFormCustomerInfo = data.baseFormCustomerInfo || {};

      if (data.orderScheduler) {
        // 用来页面上展示的
        data.dependTime = data.orderScheduler.dependTime || '';
        data.baseFormLineInfo.lineCodeName = data.orderScheduler.sourceName || '';
        data.baseFormLineInfo.lineCodeRule = data.orderScheduler.sourceCode || '';
        data.baseFormLineInfo.lineName = data.orderScheduler.sourceName || '';
        data.baseFormLineInfo.lineId = data.orderScheduler.sourceId || '';
      }

      if (data.orderGoods) {
        data.baseFormCustomerInfo.customerName = data.orderGoods.customName || '';
        data.baseFormCustomerInfo.customerId = data.orderGoods.customUserId || '';
        data.baseFormCustomerInfo.companyName = data.orderGoods.companyName || '';
        data.baseFormLineInfo.lineName = data.orderGoods.contactName || '';
        data.baseFormLineInfo.lineTel = data.orderGoods.contactPhone || '';
        data.baseFormLineInfo.desNand = data.orderGoods.nandDes || '';
        data.baseFormLineInfo.sourceEand = data.orderGoods.eand || '';
        data.baseFormLineInfo.sourceNand = data.orderGoods.nand || '';
        data.baseFormLineInfo.desEand = data.orderGoods.eandDes || '';
        data.baseFormLineInfo.des = data.orderGoods.des || '';
        data.baseFormLineInfo.desAddress = data.orderGoods.navigatDesLocation || '';
        data.baseFormLineInfo.reciveAddress = data.orderGoods.reciveAddr || '';
        data.baseFormLineInfo.reciveProvinceName = data.orderGoods.reciveProvinceName || '';
        data.baseFormLineInfo.receiveName = data.orderGoods.reciveName || '';
        data.baseFormLineInfo.receivePhone = data.orderGoods.recivePhone || '';
        data.baseFormLineInfo.source = data.orderGoods.source || '';
        data.baseFormLineInfo.sourceAddress = data.orderGoods.navigatSourceLocation || '';
        if (data.orderGoods.customNumber) {
          data.customNumber = data.orderGoods.customNumber.split('\n');
        }
      }

      if (this.$route.query.id) {
        this.otherFormData.orderId = this.$route.query.rawOrderId;
      }
      if (data.orderInfo) {
        data.createDate = data.orderInfo.createDate || '';
        this.createDate = data.createDate;
      }

      this.otherFormData.orderInfoId = data.orderInfo ? data.orderInfo.id : '';
      this.otherFormData.orderInfoExtId = data.orderInfoExt ? data.orderInfoExt.id : '';
      this.otherFormData.orderFeeId = data.orderFee ? data.orderFee.id : '';
      this.otherFormData.orderFeeExtId = data.orderFeeExt ? data.orderFeeExt.id : '';
      this.otherFormData.orderGoodsId = data.orderGoods ? data.orderGoods.id : '';
      this.otherFormData.orderSchedulerId = data.orderScheduler ? data.orderScheduler.id : '';
    },
    // 设置修改时候的状态
    setEditStatus () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['baseFormLineInfo', 'baseFormCustomerInfo'],
      });
      // 如果有线路 id 代表已经选择了线路，客户名称也不能再更改
      if (this.$refs.baseForm) {
        const baseFormLineInfo = this.$refs.baseForm.getVal('baseFormLineInfo');
        if (baseFormLineInfo.lineId) {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'disabled',
            value: true,
            names: ['baseFormCustomerInfo'],
          });
        }
      }
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 重置页面数据
      // 这里处理接口或者缓存返回的数据
      this.chooseCustomerDisabled = data.chooseCustomerDisabled;
      this.setDetailData(data);
      this.$refs.baseForm.setVal(data);
      this.setEditStatus();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
